<template>
    <div>
        <div style="text-align: left">
            <div class="searchbarcls">
                企业名称:<el-input  size="small" v-model="selTenantSearchForm.tenantName"  style="width: 200px;"></el-input>
                &nbsp;<el-button type="primary" icon="el-icon-search" size="small" @click="loadSelTenantTableData()">查询</el-button>
            </div>
        </div>
        <el-table
            ref="selTenantTable"
            background="true"
            :data="tenantTableData"
            border style="width: 100%;">
<!--            <el-table-column type="selection" width="40"/>-->
            <el-table-column type="index" label="序号" fixed="left" width="50"/>
            <el-table-column prop="tenantName" label="企业名称"/>
            <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                    <el-button type="primary" plain size="mini" @click="selectedData(scope.row)">选择</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="selTenantSearchForm.currPage"
            :page-sizes="[5,10]"
            :page-size="10"
            layout="total,jumper, prev, pager, next,sizes"
            :total="selTenantSearchForm.dataTotal">
        </el-pagination>
    </div>
</template>
<script>
    import {appjs} from "@/utiljs/apputil";
    export default {
        props: {
            setSelectedTenant:{
                type:Function
            }
        },
        data() {
            return {
                selTenantSearchForm: {
                    dataTotal:0,
                    pageSize:10,
                    currPage:1,
                    tenantName:''
                },
                tenantTableData: []
            }
        },
        created() {
            this.loadSelTenantTableData();
        },
        methods:{
            loadSelTenantTableData(){
                let load = appjs.loading();
                let _self = this;
                let params = this.selTenantSearchForm;
                appjs.httpRequest('tenant/queryTenant',params).then(
                    (data)=>{
                        if(data.retCode&&data.retCode!="ok"){
                            appjs.showErrorMsg(data.retMsg)
                        }else{
                            _self.selTenantSearchForm.dataTotal = data.totalRowNum;
                            _self.tenantTableData = data.dataList;
                            this.$refs.selTenantTable.bodyWrapper.scrollTop =0;
                        }
                        appjs.unloading(load);
                    }
                ).catch(
                (errmsg)=>{
                    appjs.showErrorMsg(errmsg)
                    appjs.unloading(load);
                });
            },
            selectedData(rowdata){
                this.setSelectedTenant(rowdata);
            },
            handleSizeChange(val) {
                this.selTenantSearchForm.pageSize = val;
                this.loadSelTenantTableData();
            },
            handleCurrentChange(val) {
                this.selTenantSearchForm.currPage = val;
                this.loadSelTenantTableData();
            }
        }
    }
</script>
